import env from "react-dotenv";

let appMode = process.env.REACT_APP_APP_MODE;
//  if(window.location.origin === process.env.WINDOWLOCATION1', false) || window.location.origin === process.env.WINDOWLOCATION2', false)) {
//     appMode = 'stage';
// } 
let newlive = process.env.REACT_APP_API_URL;//'https://eclpse.in/'
let stage = process.env.REACT_APP_API_URL;//'http://127.0.0.1:3002/'
let adminPath = '';
let adminDir = '';
let image = '';

if (appMode === 'production') {
    newlive = process.env.REACT_APP_API_URL;//'https://eclpse.in/';
    image = process.env.REACT_APP_IMAGE_URL;//'https://eclpse.in/';
    adminPath = process.env.REACT_APP_ADMIN_URL;//'https://eclpse.in/backend';
    adminDir = process.env.REACT_APP_ADMIN_DIR;//'https://eclpse.in/backend';
} else {
    stage = process.env.REACT_APP_API_URL;//'http://127.0.0.1:3002/'
    image = process.env.REACT_APP_IMAGE_URL;//'http://127.0.0.1:3002';
    adminPath = process.env.REACT_APP_ADMIN_URL;//'http://localhost:4000';
    adminDir = process.env.REACT_APP_ADMIN_DIR;//'http://localhost';

}
// let baseUrlDriver= "http://3.20.147.34/lavender_driver/";

let URL = (appMode === 'production') ? newlive : stage;

// console.log('API URL', process.env.REACT_APP_API_URL);
// console.log('Admin URL', process.env.REACT_APP_ADMIN_URL);
// console.log(URL)
let pathObj = {
    baseURL: URL,
    // baseUrlDriver:baseUrlDriver,
    //Image URL
    imageURL: image,
    adminPath: adminPath,
    adminDir: adminDir,

    //Basic Url
    adminLogin: 'api/admins/login',
    adminLogout: 'api/admins/checkAdminLogout',
    forgotPassword: 'api/admins/forgot-password',
    unlockAccountSendOTP: 'api/admins/unlock-account-send-otp',
    unlockAccountVerifyOTP: 'api/admins/unlock-account-verify-otp',
    changePassword: 'api/admins/change-password',
    dashboardData: 'api/admins/dashboardData',
    dashboardGraphData: 'api/admins/dashboardGraphData',
    updateAdminProfile: 'api/admins/updateAdminProfile',
    vendorData: 'api/admins/vendorData',
    deliveryboysData: 'api/admins/deliveryboysData',
    getStateCityArea: 'api/admins/state-city-area',
    docUploadImage: 'api/admins/doc-upload-image',
    getAdminNotifications: 'api/admins/getAdminNotifications',
    deleteNotification: 'api/admins/deleteNotification',

    //Services URL
    getServices: 'api/admins/getServices',
    addService: 'api/admins/addService',
    updateService: 'api/admins/updateService',
    updateServiceStatus: 'api/admins/updateServiceStatus',
    getAllService: 'api/admins/getAllService',

    //Banners URL
    getBanners: 'api/admins/getBanners',
    addBanner: 'api/admins/addBanners',
    updateBanner: 'api/admins/updateBanner',
    //getInAppNotification URL
    getInAppNotification: 'api/admins/getInAppNotification',
    addInAppNotification: 'api/admins/addInAppNotification',
    updateInAppNotification: 'api/admins/updateInAppNotification',
    deleteInAppNotification: 'api/admins/deleteInAppNotification',

    //Advertisements URL
    getAdvertisements: 'api/admins/getAdvertisements',
    addAdvertisement: 'api/admins/addAdvertisement',
    updateAdvertisement: 'api/admins/updateAdvertisement',

    // Users URL
    getGameCoins: 'api/admins/getGameCoins',
    getUserDetail: 'api/admins/getGameCoins',

    //Game Score URL
    getGameScore: 'api/admins/getGameScore',
    updateGameScore: 'api/admins/updateGameScore',

    //Settings URL
    getSettings: 'api/admins/getSettings',
    updateSettings: 'api/admins/updateSettings',

    //DeliveryPrice URL
    getDeliveryPrice: 'api/admins/getDeliveryPrice',
    updateDeliveryPrice: 'api/admins/updateDeliveryPrice',

    //EmailTemplates URL
    getEmailTemplates: 'api/admins/getEmailTemplates',
    updateEmailTemplate: 'api/admins/updateEmailTemplate',

    //Contents URL
    getContent: 'api/admins/getContents',
    updateContent: 'api/admins/updateContent',

    // Earn Redeem Code URL
    getEarnRedeemCodes: 'api/admins/getEarnRedeemCodes',

    // Coins URL
    getCoins: 'api/admins/getCoins',
    getCoinDetail: 'api/admins/coins/view/',
    // Coins Collection URL
    updateCoinTableData: 'api/admins/coins/updateCoinTableData',

    // AdminBills URL
    getAdminBills: 'api/admins/getAdminBills',
    updateBillStatus: 'api/admins/updateBillStatus',

    // Refer URL
    getRefers: 'api/admins/getRefers',
    updateRefer: 'api/admins/updateRefer',

    // RedeemCodesWithValues URL
    getRedeemCodesWithValues: 'api/admins/getRedeemCodesWithValues',
    updateRedeemCodesWithValue: 'api/admins/updateRedeemCodesWithValue',

    // QuizEarnRedeemCodes URL
    getQuizEarnRedeemCodes: 'api/admins/getQuizEarnRedeemCodes',
    updateQuizEarnRedeemCode: 'api/admins/updateQuizEarnRedeemCode',

    // AllRedeemCodes URL
    getAllRedeemCodes: 'api/admins/getAllRedeemCodes',

    // Users URL
    getUsers: 'api/admins/getUsers',
    getUserDetail: 'api/admins/user/view/',
    getAllUserMultiple: 'api/admins/getAllUserMultiple',
    getAllUser: 'api/admins/getAllUser',
    addUser: 'api/admins/addUser',
    updateUser: 'api/admins/updateUser',
    updateUserStatus: 'api/admins/updateUserStatus',
    updateUserStatusData: 'api/admins/updateUserStatusData',
    getAllUserCSV: 'api/admins/getAllUserCSV',
    getUserWalletHistoryes: 'api/admins/getUserWalletHistoryes',
    // User Address URL
    getUserAddresses: 'api/admins/getUserAddresses',

    // Products URL
    getProducts: 'api/admins/getProducts',
    addProduct: 'api/admins/addProduct',
    updateProduct: 'api/admins/updateProduct',
    updateProductStatus: 'api/admins/updateProductStatus',
    getAllProduct: 'api/admins/getAllProduct',
    addProductImages: 'api/admins/addProductImages',
    deleteProductImages: 'api/admins/deleteProductImages',
    uploadProductCSV: 'api/admins/uploadProductCSV',
    getAllProductCSV: 'api/admins/getAllProductCSV',

    // Sub admin URL 
    getAdmins: 'api/admins/getAdmins',
    addAdmin: 'api/admins/addAdmin',
    updateAdmin: 'api/admins/updateAdmin',
    updateAdminStatus: 'api/admins/updateAdminStatus',
    getAllRoles: 'api/admins/getAllRoles',
    unlockStatus: 'api/admins/unlockStatus',

    // Discount Code URL
    getDiscountCode: 'api/admins/getDiscountCode',
    addDiscountCode: 'api/admins/addDiscountCode',
    shareCouponCode: 'api/admins/shareCouponCode',
    updateDiscountCode: 'api/admins/updateDiscountCode',
    updateDiscountCodeStatus: 'api/admins/updateDiscountCodeStatus',

    // Order URL
    currentOrders: 'api/admins/currentOrders',
    getOrdersHistory: 'api/admins/getOrdersHistory',
    updateOrderStatus: 'api/admins/updateOrderStatus',
    updateCashStatus: 'api/admins/updateCashStatus',
    getDriverUserLatLng: 'api/admins/getDriverUserLatLng',
    getDriverLatLng: 'api/admins/getDriverLatLng',
    getOrderItems: 'api/admins/getOrderItems',

    // Refund Url
    getRefundProducts: 'api/admins/getRefundProducts',
    refundProductStatusUpdate: 'api/admins/refundProductStatusUpdate',
    getRefundReasons: 'api/admins/getRefundReasons',
    updateRefundReason: 'api/admins/updateRefundReason',

    getCancelReasons: 'api/admins/getCancelReasons',
    updateCancelReasons: 'api/admins/updateCancelReasons',

    // Product Request Url
    getProductsRequest: 'api/admins/getProductsRequest',
    updateProductsRequestStatus: 'api/admins/updateProductsRequestStatus',

    // Withdrawal Request Url
    getWithdrawalRequest: 'api/admins/getWithdrawalRequest',
    updatWithdrawalRequestStatus: 'api/admins/updatWithdrawalRequestStatus',

    // Notification Request Url
    getNotifications: 'api/admins/getNotifications',
    addNotification: 'api/admins/addNotification',
    deleteAdminNotification: 'api/admins/deleteAdminNotification',
    VerifyEmailStore: 'api/admins/verify-email-store',
    VerifyEmailDriver: 'api/admins/verify-email-driver',
    VerifyEmail: 'api/admins/verify-email',

    // Reports Request URL
    completeOrder: 'api/admins/completeOrder',

    //Country List
    countryList: 'api/users/country_list',

    // v2 Admin Leaderboard Prize Config
    getLeaderboardPrizesV2: 'v2/api/admin/leaderboard/prizes',
    updateLeaderboardPrizesV2: 'v2/api/admin/leaderboard/prizes',
    getGameLeaderboardPrizesV2: 'v2/api/admin/leaderboard/game/prizes',
    updateGameLeaderboardPrizesV2: 'v2/api/admin/leaderboard/game/prizes',

    // v2 Admin Leaderboard Period Settings
    getLeaderboardSettingsV2: 'v2/api/admin/leaderboard/settings',
    updateLeaderboardSettingsV2: 'v2/api/admin/leaderboard/settings',
    getGameLeaderboardSettingsV2: 'v2/api/admin/leaderboard/game/settings',
    updateGameLeaderboardSettingsV2: 'v2/api/admin/leaderboard/game/settings',
}
export default pathObj;
